{
  "version": 1,
  "asset_id": "eca740f7-e40b-422f-8dd4-99aa79205a3c",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/eca740f7-e40b-422f-8dd4-99aa79205a3c/loc-dallas-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/eca740f7-e40b-422f-8dd4-99aa79205a3c/loc-dallas-640.avif",
  "original_filename": "loc-dallas-640.avif",
  "size": 18367,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:20Z"
}
